<form #form="ngForm" autocomplete="off">
    <app-required-fields-card
        (onSelect)="onSelectOptionalField($event)"
        [jobPosting]="jobPosting"
    ></app-required-fields-card>

    <ui-card>
        <div class="margin-bottom-4">
            <app-segment-header [title]="'forms.applicant-tracker.autoHelpers'"></app-segment-header>
        </div>

        <app-segment-header
            title="forms.applicant-tracker.autoScoringApplicants"
            subtitle="forms.applicant-tracker.youCanProvideKeywords"
        ></app-segment-header>

        <div class="field" style="max-width: 1000px">
            <ui-chips-autocomplete
                label="forms.applicant-tracker.keywords"
                [selectedItems]="initialKeywords"
                (changes)="onChangeKeywords($event)"
                allowAdditions="true"
            ></ui-chips-autocomplete>
        </div>
    </ui-card>
</form>
